import React, {FC, useState, useEffect, useCallback} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {GoPlus} from 'react-icons/go';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
// custom
import NavbarAdmin from '../../../components/navbar/Navbar.admin';
import { IPayment, PAYMENT_ACTION_TYPE } from '../../../common/state/payments/payment';
import { IUserState } from '../../../common/state/profile/user';
import { deletePaymentByIdAdmin, getAllPayments } from '../../../common/async/AsyncCalls';
import PaymentTableAdmin from '../../../components/tables/Payment.table';
// custom

const PaymentsView : FC = () => {
    const history = useHistory();
    // states
    const [paymentList, setPaymentList] = useState<IPayment[] | undefined>(undefined);
    const token: string = useSelector(({user} : {
        user: IUserState
    }) => user.token);
    // actions
    const paymentDispatch : (data : {type: PAYMENT_ACTION_TYPE, payload: any}) => void = useDispatch();

    // evt handlers
    function handlePaymentUpdate (payment: IPayment) {        
        paymentDispatch({type: PAYMENT_ACTION_TYPE.SELECT_PAYMENT, payload: payment});
        history.push({pathname: '/admin/payments/update'});
    }    

    // lifecycle
    const handlePaymentDelete = useCallback(async(item: IPayment)=>{                             
        try {
            await deletePaymentByIdAdmin(token, item.id);
            toast("Payment record deleted successfully!");
            paymentDispatch({type: PAYMENT_ACTION_TYPE.RESET_PAYMENT, payload: undefined});
            history.push({pathname: '/admin'});
        } catch (err) {
            console.log('Error deleting payment: ', (err as Error).message);
        }
    },[token]);

    //lifecycle
    const fetchAllPayments = useCallback(async()=> {
        try {
            // console.log('Token is: ', token);
            const response = await getAllPayments();
            // console.log('details are: ', response.data);
            setPaymentList(response.data as IPayment[]);
        } catch(err) {
            console.log('Error fetching admin payments');
        }
            
    }, [token]);

    useEffect(()=>{        
        fetchAllPayments();
    },[token]);

    return <React.Fragment>
        <NavbarAdmin/>
        <div
            className="h-screen overflow-y-scroll w-screen bg-gray-200 dark:bg-gray-800 flex flex-col justify-start p-4 
                        lg:py-4 lg:px-16 items-between shadow">
            <h2 className="text-gray-700 dark:text-teal-400 text-2xl font-medium mb-2">Manage Payments</h2>
            <p className="text-gray-700 dark:text-gray-300 dartext-base mb-4">
                Create, Update, Delete payments. Please ensure atleast one payment record exists*
            </p>
            <section className="w-full flex flex-row justify-end">
                <Link to="/admin/payments/create" className="bg-primary-500 text-white flex 
                        active:bg-primary-600 font-bold uppercase text-sm px-6 py-3 rounded shadow 
                        hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear 
                        transition-all duration-150" type="button">
                     <GoPlus className="relative mt-1 mr-2 font-bold"/> Payment
                </Link>
            </section>
            <PaymentTableAdmin 
                list={paymentList} 
                onEdit={handlePaymentUpdate} 
                onDelete={handlePaymentDelete}/>
        </div>
    </React.Fragment>;
};

export default PaymentsView;